import React, { useState, useEffect } from "react";

import "./ContextMenu.css";

const ContextMenu = (props) => {

  //Props
  const Data = props.data;
  const Width = props.width || 200;
  const CurrentRef = props.currentRef;
  const OnCloseMenu = props.onCloseMenu;
  //State
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    const maxX = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const maxY = Math.max(document.documentElement.clientHeight || 0, window.innerHeight  || 0);

    let currentX = Data.posX;
    let currentY = Data.posY;

    if (currentX + Width > maxX) currentX -= Width;

    if (Data.Option){
      let currentHeight = 30 * Data.Option.filter(o => !o.separator).length;
      if (currentY + currentHeight > maxY) currentY -= currentHeight;
    }


    setPosition({x: currentX, y: currentY});

    setDisplay(Data.display);

  }, [Data, Width]);


  if (!display || !Data || !Data.Option) return null;

  return (
    <div className="contextmenu_cont" ref={CurrentRef}
      style={{left: position.x + "px", top: position.y + "px", width: Width + "px"}}>
      {Data.Option.map((o, i) => (
        <div className="contextmenu_option_cont page_noselect" key={i} onMouseDown={(o.disabled ? () => OnCloseMenu : o.onClick)}
          style={{color: (o.disabled ? "lightgrey" : "black"), height: (o.height || "30px"), marginBottom: (o.height && o.separator ? o.height : "none" ), borderBottom: (o.separator || "none")}}>
          {o.caption}
        </div>
      ))}

    </div>
  );
};

export default ContextMenu;
